import React, { BaseSyntheticEvent } from 'react'
import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonTitle,
  IonToggle,
  IonToolbar,
} from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getPatientDemographicsOptionsSelector } from '../../options/selectors/patientDemographicsOptions.selector'
import { savePatientDemographics, setDnr } from '../store/patientDemographics.actions'
import { getPatientDemographicsSelector } from '../selectors'
import { IOption, IOptions } from '../../../common/common.types'
import { Virtuoso } from 'react-virtuoso'
import { chevronBackOutline } from 'ionicons/icons'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { setSelectedOption, enableScroll } from '../../patientInformation/store/patientInformation.actions'

const DoNotResuscitateContent: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const patientDemographicsOptions = useSelector(getPatientDemographicsOptionsSelector)
  const patientDemographics = useSelector(getPatientDemographicsSelector)
  const dispatch = useDispatch()
  const { isTablet: isTabletDevice } = useDeviceMetrics()

  const { dnr } = patientDemographics
  const { dnrOptions } = patientDemographicsOptions

  const onDnrSelect = (e: BaseSyntheticEvent, option: IOption) => {
    e.preventDefault()
    const updatedDnr: IOptions = [...dnr]
    if (e.target.checked) {
      updatedDnr.push(option)
    } else {
      const index = updatedDnr.findIndex((opt) => opt.id === option.id)
      if (index !== -1) {
        updatedDnr.splice(index, 1)
      }
    }
    dispatch(setDnr(updatedDnr))
    dispatch(savePatientDemographics())
  }

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (isTabletDevice) {
      dispatch(setSelectedOption(PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION))
      history.push(TabConstants.PATIENT_INFO_ROUTE)
    } else {
      history.push(TabConstants.PATIENT_DEMOGRAPHICS)
    }
    dispatch(enableScroll(true))
  }

  return (
    <>
      <IonHeader className='ion-no-border'>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' fill='clear' onClick={onBackClick} color='primary'>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle>{t('patientDemographics.details.DoNotResuscitate')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color='light' fullscreen>
        <IonCard className={isTabletDevice ? 'card-width' : 'card-margin'}>
          {dnrOptions?.length > 0 && (
            <Virtuoso
              data={dnrOptions}
              increaseViewportBy={{ top: 2000, bottom: 2000 }}
              style={{ height: window.innerHeight, marginTop: '10px' }}
              overscan={10}
              itemContent={(index, option: IOption) => {
                return (
                  <div style={{ minHeight: '44px' }} className='webkit-line-clamp-2'>
                    <IonItem key={`Option_${option.id}`} lines='none' data-skip-auto-enhance>
                      <IonLabel>{option.name}</IonLabel>
                      <IonToggle
                        slot='start'
                        name={option.name}
                        value={`${option.id}`}
                        checked={dnr.filter((o) => o.id === option.id).length > 0}
                        onClick={(e) => onDnrSelect(e, option)}
                        color={'zoll-blue-secondary'}
                      />
                    </IonItem>
                  </div>
                )
              }}
            />
          )}
        </IonCard>
      </IonContent>
    </>
  )
}

export default DoNotResuscitateContent
